import React from "react";

function ChevronIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 515.556 515.556">
      <path d="m257.778 128.885 257.778 257.778h-128.886l-128.892-128.889-128.886 128.897-128.892-.008z" />
    </svg>
  );
}

export { ChevronIcon };
